import "../../../../assets/css/dashboard.css";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { notification, Spin } from "antd";
import { useForm } from "react-hook-form";
import {
  _change_password,
  _confirm_user_transfer_pin,
  _generate_otp,
  _request_transaction_pin_otp,
  _get_profile,
  _update_profile,
  _update_trans_pin,
  _validate_transaction_pin_otp,
  _verify_otp,
} from "../../../../common/axios_services";
import { fetchData, profileData } from "../../../../slices/profileSlice";
import RequestTransactionCode from "../../../../components/profile/transcode";
import OtpInput from "react-otp-input";
import TopNav from "../../../../components/top-nav";
import SmsVerificationRequiredCard from "../../../../components/profile/SmsVerificationRequiredCard";

const UpdateTransactionCode = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 18, color: "#fff" }} spin />
  );
  const newAntIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;
  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: "",
      description: message,
      // placement: "bottom-right"
    });
  };

  const [loadingData, setLoadingData] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [currentDispTab, setCurrentDispTab] = useState("profile");
  const [modalDispTab, setModalDispTab] = useState("otp");

  // user data
  // const profileInfo = useSelector(state => state.userProfile.dataFetched);
  const profileInfo = useSelector((state) => state);

  // basic profile
  const basicInfoValidator = yup.object().shape({
    firstName: yup.string().required("First name field is required"),
    lastName: yup.string().required("Last name field is required"),
    email: yup
      .string()
      .email("Email address is not valid")
      .required("Email address field is required"),
    phoneNumber: yup.string().required("Phone number is not valid"),
  });
  const {
    handleSubmit: handleBasicInfo,
    control: controlBasicInfo,
    setValue: setBasicInfoValue,
    formState: { errors: basicInfoError },
  } = useForm({
    resolver: yupResolver(basicInfoValidator),
  });

  // fetch user data
  const [VerActivated, setVerActivated] = useState(false);
  const [otp, setOtp] = useState(false);
  const [userGenderOption, setUserGenderOption] = useState("");
  const [userDOB, setUserDOB] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [loadingSpinner, setLoadingSpinner] = useState(true);
  const [smsVerified, setSmsVerified] = useState(true);

  const fetchUser = async () => {
    try {
      const user_profile = await _get_profile();
      dispatch(fetchData(true));
      dispatch(profileData(user_profile?.data?.data));
      setVerActivated(user_profile?.data?.data?.login_2fa);
      setSmsVerified(!!user_profile?.data?.data?.smsVerified);
      setImageUrl(user_profile?.data?.data?.image);

      let userData = user_profile?.data.data;
      setBasicInfoValue("firstName", userData.firstName);
      setBasicInfoValue("lastName", userData.lastName);
      setBasicInfoValue("email", userData.email);
      setBasicInfoValue("phoneNumber", userData.phoneNumber);
      setUserGenderOption(userData.gender ? userData.gender : "");
      setUserDOB(userData.dob ? userData.dob : "2008-02-24");
      setBasicInfoValue("userType", userData.role.user_type);
      setLoadingSpinner(false);
      if (user_profile?.data?.data?.email_otp) {
        setOtp(user_profile?.data?.data?.email_otp);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          Navigate(`/signin`);
        }
        dispatch(profileData(false));
        dispatch(fetchData(false));
      } else {
      }
    }
  };
  useEffect(() => {
    fetchUser();
    // if (searchParams.get('pin')) {
    //     setActiveTabKey('3');
    // }
    // updateCount
  }, []);

  const genderOptions = [
    {
      label: "Male",
      value: "male",
    },
    {
      label: "Female",
      value: "female",
    },
  ];

  const onChangeGenderOption = ({ target: { value } }) => {
    setUserGenderOption(value);
  };

  const onChangeUserDOB = (date, dateString) => {
    setUserDOB(dateString);
  };

  const updateUserInfo = async (e) => {
    setLoadingData(true);
    setErrorMessage("");
    try {
      let { email, firstName, lastName, phoneNumber, ageGroup, userType } = e;
      const data = {
        first_name: firstName,
        last_name: lastName,
        email,
        phone_number: phoneNumber,
        userType: userType,
        gender: userGenderOption,
        dob: "",
        image: "",
        pin: profileInfo.pin,
        age: ageGroup,
      };
      const updateProfile = await _update_profile(data);
      setErrorMessage("");
      openNotificationWithIcon("success", updateProfile?.data?.message);
      Navigate("/settings");
    } catch (err) {
      if (err?.response?.data?.message) {
        if (err?.code === "ERR_NETWORK") {
          setErrorMessage(
            "An error occurred while checking pin. Please check network and try again"
          );
        } else if (err?.response?.data?.message === "Unauthorized") {
          setErrorMessage(
            "User Authorization expired. Please log in to continue"
          );
          Navigate("/signin");
        } else {
          setErrorMessage(
            err?.data?.message.length
              ? err?.data?.message
              : err?.response?.data?.message
          );
        }
      } else {
        setErrorMessage(
          "An error occurred while checking pin. Please try again"
        );
      }
      setLoadingData(false);
    }
  };

  const editPasswordValidator = yup.object().shape({
    oldPassword: yup.string().required("Please enter your password"),
    newPassword: yup.string().required("Please enter your new password"),
    confirmPassword: yup.string().required("Please enter your new password"),
  });
  // update user password
  const {
    handleSubmit: editPasswordHandleSubmit,
    control: editPasswordControl,
    formState: { errors: editPasswordError },
  } = useForm({
    resolver: yupResolver(editPasswordValidator),
  });

  const changePassword = async (e) => {
    let { oldPassword, newPassword, confirmPassword } = e;
    setLoadingData(true);
    setErrorMessage("");
    try {
      const pass_changed = await _change_password({
        current_password: oldPassword,
        new_password: newPassword,
        confirm_new_password: confirmPassword,
      });
      setLoadingData(false);
      openNotificationWithIcon("success", pass_changed?.data?.message);
      Navigate("/settings");
    } catch (err) {
      setLoadingData(false);
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          Navigate("/signin");
          openNotificationWithIcon("error", err?.response?.data?.message);
        } else {
          // setErrorMessage(err?.response?.data?.title, err?.response?.data?.message);
          setErrorMessage(err?.response?.data?.message);
          openNotificationWithIcon("error", err?.response?.data?.message);
        }
      } else {
        setErrorMessage(err?.message);
        openNotificationWithIcon("error", err?.message);
      }
    }
  };

  // security update
  const [userOTP, setUserOTP] = useState("");
  const [updatePinVisible, setUpdatePinVisible] = useState(false);
  const [reGen, setReGen] = useState(false);
  const [verifiedOtp, setVerifiedOtp] = useState(false);
  const [transCodeDrawer, setTransCodeDrawer] = useState(false);
  const [currentOTPCounter, setCurrentOTPCounter] = useState(0);
  const [currentTransCode, setCurrentTransCode] = useState("");
  const [newTransCode, setNewTransCode] = useState("");
  const [displayTransCodeModal, setDisplayTransCodeModal] = useState(false);
  const [userTransPin, setUserTransPin] = useState("");

  const otpCheckValidator = yup.object().shape({
    otp: yup.string().required("Please enter OTP sent to your mail"),
  });
  const {
    handleSubmit: otpCheckHandleSubmit,
    control: otpCheckControl,
    formState: { errors: otpCheckError },
  } = useForm({
    // resolver: yupResolver(otpCheckValidator)
  });

  const closeTransactionCodeDrawer = () => {
    setTransCodeDrawer(false);
  };

  const controlTransCodeModalDisplay = () =>
    setDisplayTransCodeModal(!displayTransCodeModal);

  // const basicInfoValidator = yup.object().shape({
  //     firstName: yup.string().required('First name field is required'),
  //     lastName: yup.string().required('Last name field is required'),
  //     email: yup.string().email('Email address is not valid').required('Email address field is required'),
  //     phoneNumber: yup.string().required('Phone number is not valid'),
  // })
  const { handleSubmit, control, setValue } = useForm({
    resolver: yupResolver(basicInfoValidator),
  });

  const genOtp = async () => {
    setLoadingData(true);
    setLoadingSpinner(true);
    try {
      const generate_otp = await _request_transaction_pin_otp();
      setOtp(true);
      setReGen(false);
      openNotificationWithIcon("success", generate_otp?.data?.message);
      setLoadingData(false);
      setLoadingSpinner(false);
      setCurrentOTPCounter(40);
      setTransCodeDrawer(true);
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon("error", err?.response?.data?.message);
          Navigate("/signin");
        }
        openNotificationWithIcon("error", err?.response?.data?.message);
      } else {
        openNotificationWithIcon("error", err.message);
      }
      setLoadingData(false);
      setLoadingSpinner(false);
    }
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.addEventListener("load", () => callback(reader.result));
  };

  // verify otp box

  const [pageUserPin, setPageUserPin] = useState("");

  const onChangeOTPInput = (e) => {
    // console.log(e);
    // if (pageUserPin.length < 4) {
    setPageUserPin(e);
    // }
  };

  const [inputData, setInputData] = useState("");
  const [otpCounter, setOtpCounter] = useState(false);
  const [transPinErrorMessage, setTransPinErrorMessage] = useState("");

  const toggleOTPCounter = () => setOtpCounter(!otpCounter);
  const toggleTransCodeModalDisplay = () => {
    // if (pageUserPin.length === 4) {
    setDisplayTransCodeModal(!displayTransCodeModal);
    setOtpCounter(true);
    // } else {
    //     openNotificationWithIcon("error", "Please enter 4 characters")
    // }
  };

  const sendOTPToUser = async () => {
    setLoadingSpinner(true);
    try {
      const generate_otp = await _request_transaction_pin_otp();
      openNotificationWithIcon("success", generate_otp?.data?.message);
      setLoadingSpinner(false);
      toggleTransCodeModalDisplay();
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon("error", err?.response?.data?.message);
          Navigate("/signin");
        }
        openNotificationWithIcon("error", err?.response?.data?.message);
      } else {
        openNotificationWithIcon("error", err.message);
      }
      setLoadingSpinner(false);
    }
  };

  const verifyUserPin = async (e) => {
    if (pageUserPin.length === 4) {
      setLoadingData(true);
      try {
        const profile = await _confirm_user_transfer_pin({ pin: pageUserPin });
        toggleTransCodeModalDisplay();
        setLoadingData(false);
        setPageUserPin("");
      } catch (err) {
        if (err?.response?.data?.message) {
          if (err?.code === "ERR_NETWORK") {
            openNotificationWithIcon(
              "error",
              "An error occurred while checking pin. Please check network and try again"
            );
          } else if (err?.response?.data?.message === "Unauthorized") {
            openNotificationWithIcon(
              "error",
              "User Authorization expired. Please log in to continue"
            );
            Navigate("/signin");
          } else {
            openNotificationWithIcon(
              "error",
              err?.data?.message.length
                ? err?.data?.message
                : err?.response?.data?.message
            );
          }
        } else {
          openNotificationWithIcon(
            "error",
            "An error occurred while checking pin. Please try again"
          );
        }
        setLoadingData(false);
      }
    } else {
      openNotificationWithIcon(
        "error",
        "Your transaction code cannot be less than 4 digits."
      );
    }
  };

  const updatePin = async (value) => {
    setTransPinErrorMessage("");
    toggleTransCodeModalDisplay();
    try {
      const changeTransPin = await _update_trans_pin({
        email: profileInfo?.data?.email,
        otpCode: userOTP,
        new_pin: pageUserPin,
        confirm_new_pin: pageUserPin,
      });
      openNotificationWithIcon(
        changeTransPin?.data?.status,
        changeTransPin?.data?.message
      );
      setLoadingData(false);
      Navigate("/settings");
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon("error", err?.response?.data?.message);
          Navigate("/signin");
        }
        openNotificationWithIcon("error", err?.response?.data?.message);
      } else {
        setTransPinErrorMessage(err?.message);
        openNotificationWithIcon("error", "Something went wrong", err?.message);
      }
      setLoadingData(false);
    }
  };

  const VerifyOtp = async (e) => {
    setLoadingSpinner(true);
    setTransPinErrorMessage("");
    try {
      const verifyOtp = await _validate_transaction_pin_otp({
        email: profileInfo?.data?.email,
        otpCode: userOTP,
      });
      updatePin();
      openNotificationWithIcon("success", verifyOtp?.data?.message);
    } catch (err) {
      setLoadingSpinner(false);
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon(
            err?.response?.data?.status,
            err?.response?.data?.message
          );
          Navigate("/signin");
        } else {
          setTransPinErrorMessage(err?.response?.data?.message);
          openNotificationWithIcon(
            err?.response?.data?.status,
            err?.response?.data?.message
          );
        }
      } else {
        setTransPinErrorMessage(err?.message);
        openNotificationWithIcon("error", err.message);
      }
    }
  };

  return (
    <div>
      <Spin spinning={loadingSpinner} indicator={newAntIcon}>
        <div className="profile-display settings-display form-page">
          <TopNav title="Update Transaction Code" />
          <div className="display-main-content white-b">
            <div className="contain">
              <div className="mt_4">
                <div>
                  <div>
                    {errorMessage.length ? (
                      <p className="form-error mb_3">{errorMessage}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    <div className="form-group-cop">
                      <div className="main-otp-display">
                        <h5 style={{ fontSize: "1.6rem", marginBottom: 10 }}>
                          Enter new Transaction Code
                        </h5>
                        <OtpInput
                          inputType="number"
                          inputMode="numeric"
                          value={pageUserPin}
                          onChange={onChangeOTPInput}
                          numInputs={4}
                          renderSeparator={<span>-</span>}
                          renderInput={(props) => <input {...props} />}
                        />
                      </div>
                    </div>
                    <div className="welcome-buttons mt_10">
                      <div className="welcome-buttons-content mt_20">
                        {!loadingData ? (
                          <button
                            onClick={verifyUserPin}
                            className="btn-primary"
                          >
                            Generate OTP
                          </button>
                        ) : (
                          <button className="btn-primary" disabled>
                            <Spin indicator={antIcon} />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <RequestTransactionCode openDrawer={displayTransCodeModal} closeDrawer={toggleTransCodeModalDisplay}
                    inputCount={6} stateFunc={setUserOTP} actionFunction={VerifyOtp} startCounter={otpCounter} counterAction={toggleOTPCounter} /> */}
        <RequestTransactionCode
          openDrawer={displayTransCodeModal}
          closeDrawer={toggleTransCodeModalDisplay}
          inputCount={6}
          stateFunc={setUserOTP}
          actionFunction={VerifyOtp}
        />
      </Spin>
    </div>
  );
};

export default UpdateTransactionCode;
